// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://zixinoptmgfaswwbjjgi.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InppeGlub3B0bWdmYXN3d2JqamdpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTYwNTYwOTYsImV4cCI6MjA3MTYzMjA5Nn0.OgTORCgw8l7qVgrn7rRnnwaq9ceC-jkzTsslbZaNMec";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});